<template>
  <ul class="nav-menu h-100">
    <component
      :is="resolveNavItemComponent(item)"
      v-for="item in validatedTopItems"
      :key="item.header || item.title"
      :item="item"
    />

    <li
      v-if="hasMoreCategories"
      class="show-more-btn"
      @click="toggleShowAllCategories()"
    >
      <div class="show-more-btn">
        {{ showAllCategories ? "Show Less" : "Show More" }}
        <feather-icon
          v-if="showAllCategories"
          icon="ChevronUpIcon"
        />
        <feather-icon
          v-else
          icon="ChevronDownIcon"
        />
      </div>
    </li>

    <ul class="bottom-items">
      <template v-for="item in validatedDownItems">
        <li
          v-if="item.customComponent === 'vrCode'"
          :key="item.title"
          class="vrCode-btn-class"
          @click="generateVRCode"
        >
          <feather-icon
            icon="CpuIcon"
            size="11"
            class="mr-1"
            style="margin-left: 1px"
          />
          {{ item.title }}
        </li>
        <component
          :is="resolveNavItemComponent(item)"
          v-else
          :key="item.header || item.title"
          :item="item"
        />
      </template>
    </ul>
  </ul>
</template>

<script>
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { provide, ref, computed, onMounted, onUnmounted } from '@vue/composition-api'
import { mapGetters } from 'vuex'
import { getUserData, isUserLoggedIn } from '@/auth/utils'
import { VBTooltip, BSpinner } from 'bootstrap-vue'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'
import VerticalNavMenuGroup from '../vertical-nav-menu-group/VerticalNavMenuGroup.vue'

export default {
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
    BSpinner,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    settings: Object,
    collapseTogglerProp: {
      type: [String, Number, Boolean, Object],
      default: null,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    // ...mapGetters({
    //   categories: 'categories/categoryLookups'
    // }),
    hasMoreCategories() {
      const isVeroCatalogue = name => name && name.trim().toLowerCase().replace(/\s+/g, ' ') === 'verolabs catalogue'
      const fetchedCategories = (this.$store.getters['categories/lookups'] || []).filter(
        category => !isVeroCatalogue(category.name),
      )
      return fetchedCategories && fetchedCategories.length > 5
    },
    validatedTopItems() {
      return this.topItems.filter(item => this.checkValidation(item.Permission))
    },
    validatedDownItems() {
      return this.downItems.filter(item => this.checkValidation(item.Permission))
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    toggleShowAllCategories() {
      this.showAllCategories = !this.showAllCategories
    },
    isLoggedIn() {
      return isUserLoggedIn()
    },
    checkValidation(Permission) {
      if (Permission === 'logIn' && !isUserLoggedIn()) Permission = 'Public'
      if (Permission === 'logOut' && isUserLoggedIn()) Permission = 'Public'
      const is_hasPermission = this.hasPermission(Permission) || Permission === 'Public'
      return is_hasPermission
    },
    init() {
      this.$store.dispatch('categories/categoryLookups')
    },
    generateVRCode() {
      this.$store
        .dispatch('vrCode/generate')
        .then(response => {
          const expiresAt = new Date(
            Date.now() + response.data.expires_in_minutes * 60 * 1000,
          )
          const code = response.data.code.toString()
          let intervalId

          const vm = this
          const codeBoxes = code
            .split('')
            .map(ch => `<div class="code-box">${ch}</div>`)
            .join('')

          this.$swal({
            icon: 'success',
            html: `
              <div style="margin-top: 10px;">
                <p><strong>VR OTP</strong></p>
                <div style="display: flex; justify-content: center; gap: 8px; margin: 10px 0;">
                  ${codeBoxes}
                </div>
                <p><strong>Expires In:</strong>
                  <span id="countdown">${response.data.expires_in_minutes}:00</span>
                </p>
                <div id="resend-wrapper" style="margin-top: 15px; display: none;">
                  <button id="resend-btn"
                    style="background: linear-gradient(90deg, rgba(133, 13, 204, 1) 0%, rgba(15, 217, 222, 1) 100%);
                          color: white; border: none; border-radius: 6px; padding: 8px 16px; cursor: pointer;">
                    Regenerate Code
                  </button>
                </div>
              </div>
              <style>
                .code-box {
                  border: 2px solid #7367f0;
                  border-radius: 8px;
                  width: 40px;
                  height: 50px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  font-size: 20px;
                  font-weight: 600;
                  color: #fff;
                  background-color: transparent;
                  box-shadow: 0 0 4px rgba(0,0,0,0.1);
                }

              </style>
            `,
            showConfirmButton: false,
            showCloseButton: true,
            confirmButtonColor: '#7367f0',
            allowOutsideClick: true,
            customClass: {
              popup: 'versions-swal-popup',
              htmlContainer: 'versions-swal-content',
            },

            didOpen: () => {
              const countdownEl = document.getElementById('countdown')
              const resendWrapper = document.getElementById('resend-wrapper')
              const resendBtn = document.getElementById('resend-btn')

              function updateCountdown() {
                const now = new Date()
                const diff = expiresAt - now
                if (diff <= 0) {
                  clearInterval(intervalId)
                  countdownEl.innerText = 'Expired'
                  countdownEl.style.color = 'red'
                  resendWrapper.style.display = 'block'
                  resendBtn.onclick = () => vm.generateVRCode()
                  return
                }

                const minutes = Math.floor(diff / 1000 / 60)
                const seconds = Math.floor((diff / 1000) % 60)
                countdownEl.innerText = `${minutes}:${seconds
                  .toString()
                  .padStart(2, '0')}`
              }

              updateCountdown()
              intervalId = setInterval(updateCountdown, 1000)
            },
            willClose: () => clearInterval(intervalId),
          })
        })
        .catch(error => {
          // if (error.response) {
          //   this.$swal({
          //     icon: "error",
          //     title: `<h4>${error.response.data.error}</h4>`,
          //     showConfirmButton: true,
          //     confirmButtonColor: "#7367f0",
          //     allowOutsideClick: true,
          //   });
          // }
        })
    },
  },
  setup(props, { root }) {
    provide('openGroups', ref([]))
    const showAllCategories = ref(false)
    const localUserData = ref(getUserData() || {})

    const handleStorage = (event) => {
      if (event.key === 'userData') {
        try {
          localUserData.value = JSON.parse(event.newValue || '{}')
        } catch (e) {}
      } else if (event.detail && event.detail.key === 'userData') {
        try {
          localUserData.value = JSON.parse(event.detail.value || '{}')
        } catch (e) {}
      }
    }

    onMounted(() => {
      window.addEventListener('storage', handleStorage)
      window.addEventListener('storageUpdate', handleStorage)
    })

    onUnmounted(() => {
      window.removeEventListener('storage', handleStorage)
      window.removeEventListener('storageUpdate', handleStorage)
    })

    const isVeroCatalogue = titleOrName => {
      if (!titleOrName) return false
      return titleOrName.trim().toLowerCase().replace(/\s+/g, ' ') === 'verolabs catalogue'
    }

    const userName = computed(() => {
      const user = localUserData.value

      return isUserLoggedIn() && user && user.fname
        ? `${user.fname} ${user.lname || ''}`.trim()
        : null
    })

    const downItems = computed(() => {
      const baseItems = props.items.filter(item => item.position === 'down' && !isVeroCatalogue(item.title))
      const result = []

      if (isUserLoggedIn()) {
        result.push({
          title: 'VR Code',
          icon: 'CpuIcon',
          customComponent: 'vrCode',
          Permission: 'Public',
          position: 'down',
        })
      }

      baseItems.forEach(item => {
        if (item.title === 'My Profile' && !isUserLoggedIn()) return

        if (item.title === 'My Profile' && isUserLoggedIn()) {
          result.push({ ...item, title: userName.value || 'My Profile' })
        } else {
          result.push(item)
        }
      })

      return result
    })

    const topItems = computed(() => {
      const staticItems = props.items.filter(item => item.position === 'top' && !isVeroCatalogue(item.title))
      const fetchedCategories = (root.$store.getters['categories/lookups'] || []).filter(
        category => !isVeroCatalogue(category.name),
      )
      const categoriesToShow = showAllCategories.value
        ? fetchedCategories
        : fetchedCategories.slice(0, 5)

      const dynamicCategories = categoriesToShow.map(category => ({
        title: category.name,
        icon: 'Homeicon',
        route: { name: `filter_${category.id}`, params: { id: category.id } },
        Permission: 'Public',
        position: 'top',
      }))

      return [...staticItems, ...dynamicCategories]
    })

    return {
      resolveNavItemComponent,
      topItems,
      downItems,
      showAllCategories,
    }
  },
}
</script>

<style scoped>
.nav-menu {
  display: flex !important;
  flex-direction: column !important;
  padding: 0 !important;
  margin: 0 !important;
  list-style: none !important;
  /* height: 88vh !important; */
}

.bottom-items {
  margin-top: auto !important;
}

.vrCode-btn-class {
  display: block;
  margin-left: 0rem;
  padding: 1rem;
  cursor: pointer;
  color: #ffffffcb;
  transition: background 0.3s;
}

.vrCode-btn-class:hover {
  background-color: rgba(115, 103, 240, 0.1);
  color: #fff;
}

.show-more-btn {
  display: block;
  margin-left: 1rem;
  padding: 0.5rem 1rem;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  list-style: none;
  color: #ffffffcb;
}

.swal2-close {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}
.swal2-close:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}
</style>
